export default __webpack_public_path__ + "static/media/ultraFastDeliv_img.d3131278.jpg";